export default {"src":"/_next/static/media/0x93b346b6bc2548da6a1e7d98e9a421b42541425b.38635f67.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};